import { render, staticRenderFns } from "./UpdateCcicContainerStatusForm.vue?vue&type=template&id=67e1ef78&scoped=true"
import script from "./UpdateCcicContainerStatusForm.vue?vue&type=script&lang=js"
export * from "./UpdateCcicContainerStatusForm.vue?vue&type=script&lang=js"
import style0 from "./UpdateCcicContainerStatusForm.vue?vue&type=style&index=0&id=67e1ef78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e1ef78",
  null
  
)

export default component.exports